import { createRoutine } from 'redux-saga-routines';

export const submitPasswordReset = createRoutine(
  '@ACCOUNT_RECOVERY/SUBMIT_PASSWORD_RESET'
);
